import React from 'react';

import Radio, { RadioChangeEvent } from 'antd/es/radio';

import { disabledFilterGroup, templateSignedFilterGroup } from '@app/components/Pages/Admin/Reports/Base/BaseReport';

interface Props {
	value: boolean | undefined;
	onChange: (value: boolean | undefined) => void;
	withIcons?: boolean;
	className?: string;
	disabled?: boolean;
	allAsText?: boolean;
}

const TemplateSignedFilter: React.FC<Props> = (props) => {
	const {
		value, onChange, withIcons, className = 'pull-right ml10 mb10 custom-radio', children, disabled, allAsText,
	} = props;
	const handleChange = (e: RadioChangeEvent) => {
		onChange(e.target.value);
	};

	return (
		<Radio.Group
			className={className}
			name="templateSigned"
			value={value ?? undefined}
			onChange={handleChange}
			disabled={disabled}
			defaultValue={undefined}
		>
			{children || templateSignedFilterGroup.map((item, index) => (
				<Radio.Button value={item.value} key={item.caption}>
					<div className="custom-radio-button" title={item.caption}>
						{withIcons && !(item.value === undefined && allAsText) ? (
							<i
								className={`fa fa-${item.value !== undefined
									? item.value
										? 'pencil'
										: 'window-close-o'
									: 'users'}`}
								title={item.caption}
								aria-hidden="true"
							/>
						) : item.caption}
					</div>
				</Radio.Button>
			))}
		</Radio.Group>
	);
};

export default TemplateSignedFilter;
